import Job from '../../pages/job'

const jobRoute = [
  {
    path: '/job',
    name: 'job',
    component: Job
  }
]

export default jobRoute



// WEBPACK FOOTER //
// ./src/router/job/index.js